module.exports = __webpack_public_path__ + "img/map-bg.6893a7ba.svg";